module.exports = __webpack_public_path__ + "static/42-7325fa4d0d1d9d1a17ad860a3f8d2b22.png";